import { round2 } from './money'

/**
 * A service provider's earning for a job, for display. Mirrors the backend's
 * SpPayoutCalculator.jobEarning, which is what is actually paid (the server works
 * the earning out itself and ignores any figure the app posts):
 *
 *   earning = (total - discount) - commission% of (total - discount) - card fee% of total
 *
 * Since Oct 2026 the commission is charged on the amount after the regular discount
 * (category / new-user discount), not on the total; the stored percentages were
 * rescaled so earnings stayed the same (22% became 23.91% at the 8% discount).
 * A booking offer (reward points, serviceCosts.offerDiscount) is not the discount
 * here: StringsSG pays it, so it never lowers the earning.
 *
 * The earning is rounded once, from the unrounded parts, as the server does; the
 * parts are rounded for showing.
 */
export const spEarning = ({ total, discount = 0, commissionPercent = 0, cardFeePercent = 3.4 }) => {
    const t = Number(total) || 0
    const d = Number(discount) || 0
    const afterDiscount = t - d
    const commission = Math.max(0, afterDiscount) * (Number(commissionPercent) || 0) / 100
    const cardFee = t * cardFeePercent / 100
    return {
        afterDiscount: round2(afterDiscount),
        commission: round2(commission),
        cardFee: round2(cardFee),
        earning: round2(afterDiscount - commission - cardFee),
    }
}
